/**
 * @generated SignedSource<<3af577c2f27f7f76009e111dd145aebe>>
 * @relayHash 5a347b034bc5b5e3435dc1c041522fa4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8af4e0fcb4ac1392c7693b4c6584163f8d8e761b7271227ac6efc3e881a131b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraWorkManagementFilterSearchInput = {
  contextId: string;
  favoritesOnly?: boolean | null | undefined;
  keyword?: string | null | undefined;
};
export type FiltersMenuContentQuery$variables = {
  first?: number | null | undefined;
  searchParameters: JiraWorkManagementFilterSearchInput;
};
export type FiltersMenuContentQuery$data = {
  readonly jira: {
    readonly jwmFilters: {
      readonly edges?: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        };
      } | null | undefined>;
      readonly message?: string | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"SavedFilters_filters">;
  };
};
export type FiltersMenuContentQuery = {
  response: FiltersMenuContentQuery$data;
  variables: FiltersMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchParameters"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchParameters",
    "variableName": "searchParameters"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SavedFilters_filters"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "jwmFilters",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraWorkManagementFilterEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraWorkManagementFilter",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v3/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.id"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.name"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.jwmFilters.edges.node"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jwmFilters.edges"
                      }
                    ],
                    "type": "JiraWorkManagementFilterConnection"
                  },
                  (v5/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.jwmFilters"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "jwmFilters",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jql"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraWorkManagementFilterConnection"
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b8af4e0fcb4ac1392c7693b4c6584163f8d8e761b7271227ac6efc3e881a131b",
    "metadata": {},
    "name": "FiltersMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5de8c2e7450cfdfe562df2d282ac6707";

export default node;
